import {  SignalRTypes } from '.'

export function joinGroup(groupName) {
	return {
		type: SignalRTypes.Join_Request,
		groupName
	}
}

export function partGroup(groupName) {
	return {
		type: SignalRTypes.Part_Request,
        groupName
	}
}

export function reConnect() {
	return {
		type: SignalRTypes.Re_Connect,
	}
}
export function disconnect() {
	return {
		type: SignalRTypes.Disconnect_Request,	}
}

export function jackpotConnect() {
	return {
		type: SignalRTypes.Jackpot_Connect_Request,	}
}

export function jackpotDisconnect() {
	return {
		type: SignalRTypes.Jackpot_Disconnect_Request,	}
}

export function staticConnect() {
	window.log("Static_Connect_Request");
	return {
	
		type: SignalRTypes.Static_Connect_Request	}
}

export function staticDisconnect() {
	window.log("Static_Disconnect_Request");
	return {
		type: SignalRTypes.Static_Disconnect_Request	}
}

export function liveConnect() {
	window.log("Live_Connect_Request");
	return {
	
		type: SignalRTypes.Live_Connect_Request	}
}

export function liveDisconnect() {
	window.log("Live_Disconnect_Request");
	return {
		type: SignalRTypes.Live_Disconnect_Request	}
}

export function virtualConnect() {
	window.log("Virtual_Connect_Request");
	return {
	
		type: SignalRTypes.Virtual_Connect_Request	}
}

export function virtualDisconnect() {
	window.log("Virtua_Disconnect_Request");
	return {
		type: SignalRTypes.Virtual_Disconnect_Request	}
}

export function luckyNumbersConnect() {
	window.log("LuckyNumbers_Connect_Request");
	return {
	
		type: SignalRTypes.LuckyNumbers_Connect_Request	}
}

export function luckyNumbersDisconnect() {
	window.log("LuckyNumbers_Disconnect_Request");
	return {
		type: SignalRTypes.LuckyNumbers_Disconnect_Request	}
}

export function spinAndWinConnect() {
	window.log("SpinAndWin_Connect_Request");
	return {
	
		type: SignalRTypes.SpinAndWin_Connect_Request	}
}

export function spinAndWinDisconnect() {
	window.log("SpinAndWin_Disconnect_Request");
	return {
		type: SignalRTypes.SpinAndWin_Disconnect_Request	}
}

export function GetCurrentBanner(bannerGroupId , GroupId) {
	return {
		type: SignalRTypes.Get_Current_Banner_Request,	
		bannerGroupId,
		GroupId
	}
}
export function GetCustomBetOddFieldData(request) {
	return {
		type: SignalRTypes.Get_Custom_Bet_Odd_Field_Data_Request,	
		request
	}
}


